<!--==========================
=            TABS            =
===========================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Tabs</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Content

          </div>
          <div slot="card-subheader">It is common to put v-tabs inside the extension slot of v-toolbar. Using
            v-toolbar's tabs prop auto adjusts its height to 48px to match v-tabs.</div>
          <div slot="card-body">
            <tab-content></tab-content>
          </div>
        </base-card>
      </v-col>
      
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Icon and Text
          </div>
          <div slot="card-subheader">Using icons-with-text prop increases the v-tabs height to 72px to allow for both
            icons as well as text to be used.</div>
          <div slot="card-body">

            <tab-iconand-text></tab-iconand-text>
          </div>

        </base-card>
      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Desketop
          </div>
          <div slot="card-subheader">You can represent v-tab actions by using single icons. </div>
          <div slot="card-body">
            <tab-desktop></tab-desktop>
          </div>
        </base-card>
      </v-col>
     
    
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Dynamic Height
          </div>
          <div slot="card-subheader">When changing your v-tab-item, the content area will smoothly scale to the new
            size.</div>
          <div slot="card-body">

            <tab-dynamic-heigh></tab-dynamic-heigh>
          </div>

        </base-card>
      </v-col>
      <v-col class="col-12 col-md-6 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Overflow to menu
          </div>
          <div slot="card-subheader">You can use a menu to hold additional tabs, swapping them out on the fly.</div>
          <div slot="card-body">

            <tab-overflowtomenu></tab-overflowtomenu>
          </div>

        </base-card>
      </v-col>
      
 <v-col class="col-12 col-md-12 col-sm-12">
        <base-card>
          <div slot="card-header">
            Tab Vertical
          </div>
          <div slot="card-subheader">The vertical prop allows for v-tab components to stack vertically.</div>
          <div slot="card-body">

            <tab-vertical></tab-vertical>
          </div>

        </base-card>

      </v-col>


    </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from "../../components/Base/BaseHeader.vue";
  import TabContent from "../../components/Tabs/TabContent.vue";
  import TabDesktop from "../../components/Tabs/TabDesktop.vue";

  import TabDynamicHeigh from "../../components/Tabs/TabDynamicHeigh.vue";
  import TabIconandText from "../../components/Tabs/TabIconandText.vue";
 
  import TabOverflowtomenu from "../../components/Tabs/TabOverflowtomenu.vue";

  import TabVertical from "../../components/Tabs/TabVertical.vue";
 
  export default {
    components: {
      BaseCard,
      BaseHeader,
      TabContent,
      TabDesktop,
  
      TabDynamicHeigh,
      TabIconandText,
      
      TabOverflowtomenu,

      TabVertical,
      
    },
    data() {
      return {
        tab: null,
        items: [
          'web', 'shopping', 'videos', 'images', 'news',
        ],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      }
    },

  };
</script>

<!--====  End of TABS  ====-->
